import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  DcuMtuCommunicationCountsResponse,
  DcuMtuCommunicationPayload,
  DcuToMtuCommunicationTable,
  UserConfigDcuToMtuFilters
} from '../dcu-to-mtu-communication.types';
import { ReportGroupFilterResponse } from '../../../../services/api/report-group-filter/report-group-filter-api.types';
import { SearchType } from '@ui/aos-lib';
import { ExportFileType } from 'src/app/services/utility/export-facade.service';

export const DcuToMtuCommunicationActions = createActionGroup({
  source: 'Dcu To Mtu Communication',
  events: {
    'Fetch Table Data': emptyProps(),
    'Fetch Table Data Success': props<{ data: DcuToMtuCommunicationTable }>(),
    'Fetch Table Data Failure': props<{ error: string }>(),

    'Fetch Coverage Statistics': emptyProps(),
    'Fetch Coverage Statistics Success': props<{ data: DcuMtuCommunicationCountsResponse }>(),
    'Fetch Coverage Statistics Failure': props<{ error: string }>(),

    'Fetch Report Group Failure': props<{ error: string }>(),

    'Get Persisted Filters State': emptyProps(),
    'Save Persisted Filters State': emptyProps(),

    'Get Filters And Init Filters State': props<{
      filtersState: UserConfigDcuToMtuFilters | null;
      restoredTake?: number;
    }>(),
    'Get Filters And Init Filters State Success': props<{
      data: ReportGroupFilterResponse[];
      filtersState: UserConfigDcuToMtuFilters | null;
      restoredTake?: number;
    }>(),

    'Update Payload By Filter': props<{ payload: DcuMtuCommunicationPayload }>(),
    'Toggle Reset Button': props<{ isResetVisible: boolean }>(),
    'Reset Button': emptyProps(),
    'Update Search': props<{ search: SearchType }>(),
    'Search Type Changed': props<{ isChanged: boolean }>(),

    'Export File': props<{
      order: Record<string, number> | null;
      visibility: Record<string, boolean> | null;
      fileType: ExportFileType;
    }>(),
    'Export File Success': emptyProps(),
    'Export File Failure': props<{ error: string }>(),

    'Fetch Data': emptyProps(),
    'Reset Search': emptyProps(),
    Refresh: emptyProps()
  }
});
